import EditPermissions from "./EditPermissions.js";
export default EditPermissions;
